import { from } from 'rxjs'
// eslint-disable-next-line no-unused-vars
import { tap, groupBy } from 'rxjs/operators'
import { getPathValue } from './common'

// key is from input of experience API, such as headFundFacts.fundProvider
function innerGroupBy(fundItems, key) {
  const fundItem$ = from(fundItems)
  if (key) {
    const ret = []
    const group$ = fundItem$.pipe(
      groupBy((fundItem) => getPathValue(fundItem, key, ''))
      // tap((val) => console.log(`innerGroupBy after group: ${val.key}`))
    )
    group$.subscribe((item$) => {
      const tempGroup = []
      item$.subscribe((item) => {
        tempGroup.push(item)
      })
      ret.push(tempGroup)
    })
    return ret
  }
  return [fundItems]
}

// eslint-disable-next-line import/prefer-default-export
export { innerGroupBy as groupBy }
